import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import enCommon from "./locales/en/common.json";
import enAuth from "./locales/en/auth.json";
import enDashboard from "./locales/en/dashboard.json";
import enWallet from "./locales/en/wallet.json";
import enBatches from "./locales/en/batches.json";
import enSettings from "./locales/en/settings.json";
import enLanding from "./locales/en/landing.json";
import enAdmin from "./locales/en/admin.json";
import enSupport from "./locales/en/support.json";
import enLegal from "./locales/en/legal.json";
import enEsoft from "./locales/en/esoft.json";

import ruCommon from "./locales/ru/common.json";
import ruAuth from "./locales/ru/auth.json";
import ruDashboard from "./locales/ru/dashboard.json";
import ruWallet from "./locales/ru/wallet.json";
import ruBatches from "./locales/ru/batches.json";
import ruSettings from "./locales/ru/settings.json";
import ruLanding from "./locales/ru/landing.json";
import ruAdmin from "./locales/ru/admin.json";
import ruSupport from "./locales/ru/support.json";
import ruLegal from "./locales/ru/legal.json";
import ruEsoft from "./locales/ru/esoft.json";

import elCommon from "./locales/el/common.json";
import elAuth from "./locales/el/auth.json";
import elDashboard from "./locales/el/dashboard.json";
import elWallet from "./locales/el/wallet.json";
import elBatches from "./locales/el/batches.json";
import elSettings from "./locales/el/settings.json";
import elLanding from "./locales/el/landing.json";
import elAdmin from "./locales/el/admin.json";
import elSupport from "./locales/el/support.json";
import elLegal from "./locales/el/legal.json";
import elEsoft from "./locales/el/esoft.json";

import ukCommon from "./locales/uk/common.json";
import ukAuth from "./locales/uk/auth.json";
import ukDashboard from "./locales/uk/dashboard.json";
import ukWallet from "./locales/uk/wallet.json";
import ukBatches from "./locales/uk/batches.json";
import ukSettings from "./locales/uk/settings.json";
import ukLanding from "./locales/uk/landing.json";
import ukAdmin from "./locales/uk/admin.json";
import ukSupport from "./locales/uk/support.json";
import ukLegal from "./locales/uk/legal.json";
import ukEsoft from "./locales/uk/esoft.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: enCommon,
        auth: enAuth,
        dashboard: enDashboard,
        wallet: enWallet,
        batches: enBatches,
        settings: enSettings,
        landing: enLanding,
        admin: enAdmin,
        support: enSupport,
        legal: enLegal,
        esoft: enEsoft,
      },
      ru: {
        common: ruCommon,
        auth: ruAuth,
        dashboard: ruDashboard,
        wallet: ruWallet,
        batches: ruBatches,
        settings: ruSettings,
        landing: ruLanding,
        admin: ruAdmin,
        support: ruSupport,
        legal: ruLegal,
        esoft: ruEsoft,
      },
      el: {
        common: elCommon,
        auth: elAuth,
        dashboard: elDashboard,
        wallet: elWallet,
        batches: elBatches,
        settings: elSettings,
        landing: elLanding,
        admin: elAdmin,
        support: elSupport,
        legal: elLegal,
        esoft: elEsoft,
      },
      uk: {
        common: ukCommon,
        auth: ukAuth,
        dashboard: ukDashboard,
        wallet: ukWallet,
        batches: ukBatches,
        settings: ukSettings,
        landing: ukLanding,
        admin: ukAdmin,
        support: ukSupport,
        legal: ukLegal,
        esoft: ukEsoft,
      },
    },
    fallbackLng: "en",
    supportedLngs: ["en", "ru", "el", "uk"],
    defaultNS: "common",
    ns: ["common", "auth", "dashboard", "wallet", "batches", "settings", "landing", "admin", "support", "legal", "esoft"],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "i18nextLng",
      caches: ["localStorage"],
    },
  });

export default i18n;
